import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getEmailConfig = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/email-config`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const updateEmailConfig = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.put(`${BASE_URL}/partners/email-config`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const listPools = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/pools`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data; // { items, page, pageSize, totalItems, totalPages }
};

export const createPool = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/pools`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const updatePool = async (poolId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.patch(`${BASE_URL}/partners/pools/${poolId}`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const deletePool = async (poolId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.delete(`${BASE_URL}/partners/pools/${poolId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const listPoolMembers = async (poolId, params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/pools/${poolId}/members`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data; // { items, page, pageSize, totalItems, totalPages }
};

export const addPoolMember = async (poolId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/pools/${poolId}/members`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const updatePoolMember = async (poolId, memberId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.patch(`${BASE_URL}/partners/pools/${poolId}/members/${memberId}`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const deletePoolMember = async (poolId, memberId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.delete(`${BASE_URL}/partners/pools/${poolId}/members/${memberId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};


// ── Email Config Verification ──

export const verifyEmailConfig = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/email-config/verify`, {}, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// ── Missions ──

export const listMissions = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/missions`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const createMission = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/missions`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const getMission = async (missionId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/missions/${missionId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const getMissionDeliveryStats = async (missionId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/missions/${missionId}/delivery-stats`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const updateMission = async (missionId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.patch(`${BASE_URL}/partners/missions/${missionId}`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const sendMission = async (missionId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/missions/${missionId}/send`, {}, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// POST /partners/missions/{id}/close body: { notifyApplicants: bool }
// notifyApplicants=true emails the direct applicants that the position is filled.
export const closeMission = async (missionId, options = {}) => {
  const { buId, notifyApplicants = false } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/missions/${missionId}/close`, { notifyApplicants }, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const getMissionApplications = async (missionId, params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/missions/${missionId}/applications`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const getMissionLink = async (missionId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/missions/${missionId}/link`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// ── Public Landing Page (no auth) ──

export const getPublicMissionInfo = async (token) => {
  const response = await axios.get(`${BASE_URL}/partners-public/apply/${token}`);
  return response.data;
};

export const submitPublicApplication = async (token, formData) => {
  const response = await axios.post(`${BASE_URL}/partners-public/apply/${token}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const getPublicMissionStatus = async (token) => {
  const response = await axios.get(`${BASE_URL}/partners-public/apply/${token}/status`);
  return response.data;
};

// ── Public Unsubscribe (no auth) ──

export const getPublicUnsubscribeInfo = async (token) => {
  const response = await axios.get(`${BASE_URL}/partners-public/unsubscribe/${token}`);
  return response.data;
};

export const submitPublicUnsubscribe = async (token) => {
  const response = await axios.post(`${BASE_URL}/partners-public/unsubscribe/${token}`);
  return response.data;
};

// ── Partners Statistics (monthly buckets) ──

export const getPartnersStatistics = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/statistics`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

export const extractSkillsFromCv = async (file) => {
  const formData = new FormData();
  formData.append("cv", file);
  const response = await axios.post(`${BASE_URL}/partners-public/extract-skills`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// ── RFP Extraction ──

export const extractRfp = async (file, options = {}) => {
  const { buId } = options || {};
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(`${BASE_URL}/partners/missions/extract-rfp`, formData, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

// AI-rephrase the mission content into reader-friendly public prose sections.
export const generateMissionSections = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/missions/generate-sections`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data; // { responsibilities, requiredSkills, candidateProfile }
};

// Render the consultant email for an unsaved draft mission (final-step preview).
// Accepts the same payload as createMission (plus optional sampleFirstName) and
// returns { html } — the exact email the backend would send.
export const previewMissionEmail = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/missions/preview`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data; // { html }
};

// ── Partner Code ──

export const getMyPartnerCode = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/my-partner-code`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// ── Partner Links ──

export const listPartnerLinks = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/partner-links`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const createPartnerLink = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/partner-links`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const deletePartnerLink = async (linkId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.delete(`${BASE_URL}/partners/partner-links/${linkId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// ── Incoming Missions (Company B view) ──

export const listIncoming = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/incoming`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const getIncoming = async (incomingId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/incoming/${incomingId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const updateIncoming = async (incomingId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.patch(`${BASE_URL}/partners/incoming/${incomingId}`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const submitCandidate = async (incomingId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/incoming/${incomingId}/submit-candidate`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const uploadSourceCv = async (file, options = {}) => {
  const { buId } = options || {};
  const formData = new FormData();
  formData.append("cv", file);
  const response = await axios.post(`${BASE_URL}/partners/upload-source-cv`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(buId ? { "X-Business-Unit-Id": buId } : {}),
    },
  });
  return response.data;
};

export const addToPoolFromApplication = async (poolId, applicationId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/partners/pools/${poolId}/members/from-application/${applicationId}`, {}, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const downloadApplicationCv = async (applicationId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/applications/${applicationId}/download-cv`, {
    responseType: "blob",
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response;
};

export const downloadSubmissionCv = async (submissionId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/submissions/${submissionId}/download-cv`, {
    responseType: "blob",
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response;
};

export const listIncomingSubmissions = async (incomingId, params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/incoming/${incomingId}/submissions`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const getMissionSubmissions = async (missionId, params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/missions/${missionId}/submissions`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// ── PILOT Integration (Phase 5) ──

export const listPilotNeeds = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/pilot-needs`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const createConsultantFromApplication = async (applicationId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/partners/applications/${applicationId}/create-consultant`,
    {},
    { ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}) }
  );
  return response.data;
};

// ── Dashboard KPIs (Phase 5) ──

export const getDashboardKpis = async (options = {}) => {
  const { buId, period } = options || {};
  const params = {};
  if (period) params.period = period;
  const response = await axios.get(`${BASE_URL}/partners/dashboard/kpis`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// ── SKILLS Integration (Phase 6) ──

export const listSkillQuestionnaires = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/partners/skill-questionnaires`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const attachEvaluation = async (missionId, data, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/partners/missions/${missionId}/attach-evaluation`,
    data,
    { ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}) }
  );
  return response.data;
};


// ── Consultant Proposals (2026-04 partner feedback) ──

export const createConsultantProposal = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/partners/consultant-proposals`,
    payload,
    { ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}) }
  );
  return response.data;
};

export const createConsultantProposalFromCv = async (formData, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/partners/consultant-proposals/upload-cv`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...(buId ? { "X-Business-Unit-Id": buId } : {}),
      },
    }
  );
  return response.data;
};

export const listSentConsultantProposals = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(
    `${BASE_URL}/partners/consultant-proposals`,
    {
      params,
      ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
    }
  );
  return response.data;
};

export const listReceivedConsultantProposals = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(
    `${BASE_URL}/partners/consultant-proposals/incoming`,
    {
      params,
      ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
    }
  );
  return response.data;
};

export const decideConsultantProposal = async (proposalId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/partners/consultant-proposals/${proposalId}/decision`,
    payload,
    { ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}) }
  );
  return response.data;
};

export const matchConsultantProposalAgainstNeeds = async (proposalId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/partners/consultant-proposals/${proposalId}/match`,
    {},
    { ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}) }
  );
  return response.data;
};


// ── Pool Members: Bulk CV Upload ──

export const bulkAddPoolMembersFromCvs = async (poolId, files, options = {}) => {
  const { buId } = options || {};
  const formData = new FormData();
  files.forEach((file) => formData.append("cvFiles", file));
  const response = await axios.post(
    `${BASE_URL}/partners/pools/${poolId}/members/bulk-cv`,
    formData,
    buId ? { headers: { "X-Business-Unit-Id": buId } } : undefined
  );
  return response.data;
};


// ── Pool Members: CSV / XLSX Import ──
// Backend expects: POST /partners/pools/{poolId}/members/import with "file" (CSV or .xlsx)
// Returns a PoolMemberImportResponse:
//   { items, totalRows, addedRows, updatedRows, deletedRows, duplicateRows, skippedRows }
export const importPoolMembersFromFile = async (poolId, file, options = {}) => {
  const { buId } = options || {};
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(
    `${BASE_URL}/partners/pools/${poolId}/members/import`,
    formData,
    buId ? { headers: { "X-Business-Unit-Id": buId } } : undefined
  );
  return response.data;
};
